import React from "react";

import { planChoosePlanUrl, planPlanForUrl } from "@/mk2/apps/plan/urls";
import { Link } from "@/mk2/components/Link";
import { PlusBadge } from "@/mk2/components/PlusBadge";
import { PlusProBadge } from "@/mk2/components/PlusProBadge";
import { ProBadge } from "@/mk2/components/ProBadge";
import { url } from "@/mk2/helpers/urls";
import { Plan, UserEntity } from "@/mk2/schemas";
import { YOU_DO_NOT_HAVE_ACTIVE_PLAN } from "@/mk/autogenerated/translations/SellerProPlusBadge.1186a818dd326f5ddf06b4ffe0e32fc6";

interface OwnProps {
    className?: string;
    isSeller?: boolean;
    user: UserEntity;
    showPromo?: boolean;
}

type Props = OwnProps;

const SellerProPlusBadge: React.FunctionComponent<Props> = ({
    className,
    isSeller,
    user,
    showPromo = true,
}) => {
    let badge = null;

    // PRO / PLUS badges / promo
    if (isSeller) {
        // owner perspective
        if (user.activePlan === Plan.PRO) {
            const gotoUrl = url(
                planPlanForUrl,
                { username: user.username },
                { src: "my-bazaar-plus" },
            );
            badge = (
                <Link to={gotoUrl} className={className}>
                    <ProBadge />
                </Link>
            );
        } else if (user.activePlan === Plan.PLUS) {
            const gotoUrl = url(
                planPlanForUrl,
                { username: user.username },
                { src: "my-bazaar-plus" },
            );
            badge = (
                <Link to={gotoUrl} className={className}>
                    <PlusBadge />
                </Link>
            );
        } else if (showPromo) {
            const gotoUrl = url(planChoosePlanUrl, {}, { src: "seller" });
            badge = (
                <span className={className}>
                    {YOU_DO_NOT_HAVE_ACTIVE_PLAN}&nbsp;
                    <Link className="plus" to={gotoUrl}>
                        <PlusProBadge />
                    </Link>
                </span>
            );
        }
    } else {
        // visitor perspective
        const gotoUrl = url(planChoosePlanUrl, {}, { src: "seller" });
        if (user.activePlan === Plan.PRO) {
            badge = (
                <Link className={className} to={gotoUrl}>
                    <ProBadge />
                </Link>
            );
        } else if (user.activePlan === Plan.PLUS) {
            badge = (
                <Link className={className} to={gotoUrl}>
                    <PlusBadge />
                </Link>
            );
        }
    }

    return badge;
};

SellerProPlusBadge.displayName = "SellerProPlusBadge";

export default SellerProPlusBadge;
